import React, { useState } from 'react';
import Modal from 'react-modal';
import './AddTodoModal.css';

function AddTodoModal({ isOpen, onRequestClose, onAddTodo, selectedDate }) {
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAdd = () => {
    if (inputValue.trim() === '') return;
    onAddTodo(inputValue);
    setInputValue('');
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="add-todo-modal"
      overlayClassName="add-todo-overlay"
    >
      <h2>{selectedDate} - 할 일 추가</h2>
      <div className="input-container">
        <i className="fas fa-pencil-alt"></i>
        <textarea
          value={inputValue}
          onChange={handleInputChange}
          placeholder="할 일을 입력하세요"
          className="add-todo-input"
          rows="3"
        ></textarea>
      </div>
      <div className="add-todo-buttons">
        <button onClick={handleAdd} className="add-button">추가</button>
        <button onClick={onRequestClose} className="cancel-button">취소</button>
      </div>
    </Modal>
  );
}

export default AddTodoModal;